export default __webpack_public_path__ + "static/media/rr7.fb5a446a.jpg";